import { __extends } from "tslib";
import { StratusClient } from '../stratus-client';
import { UrlBuilder } from '../../utils/url-builder';
var ShortcutsTenantMgrSvcClient = /** @class */ (function (_super) {
    __extends(ShortcutsTenantMgrSvcClient, _super);
    function ShortcutsTenantMgrSvcClient() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.apiName = 'ws-hp.com/shortcutstenantmgr';
        _this.apiVersion = '1';
        _this.createSessionEndpoint = new UrlBuilder('/devices/:deviceUuid/sessions');
        _this.createShortcutEndpoint = '/shortcuts';
        return _this;
    }
    ShortcutsTenantMgrSvcClient.prototype.createSession = function (deviceUuid) {
        return this.jarvisWebHttpInstance.post({
            url: this.createSessionEndpoint
                .setPathVariable('deviceUuid', deviceUuid)
                .toString(),
        });
    };
    ShortcutsTenantMgrSvcClient.prototype.createShortcut = function (data, origin) {
        return this.jarvisWebHttpInstance.post({
            url: this.createShortcutEndpoint,
            params: { origin: origin },
            headers: { 'Content-Type': 'application/json' },
            data: data,
        });
    };
    return ShortcutsTenantMgrSvcClient;
}(StratusClient));
export { ShortcutsTenantMgrSvcClient };
//# sourceMappingURL=shortcuts-tenant-mgr-svc.js.map